import React, {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import "./AvvisiPreview.css";
import UserAvatar from "../../../Controls/UserAvatar.mjs";
import DateLabel from "../../../Controls/DateLabel.mjs";
import TextLabel from "../../../Controls/TextLabel.mjs";
import appLib from "../../../libs/appLib.mjs";
import {Button, ButtonGroup} from "reactstrap";
import ReplyAllIcon from "../../../media/images/ReplyAllIcon.mjs";
import CloseIcon from "../../../media/images/CloseIcon.mjs";
import ReadIcon from "../../../media/images/ReadIcon.mjs";
import AvvisiPreviewRecipients from "./AvvisiPreviewRecipients.mjs";

const prefix = "AvvisiPreview";

const AvvisiPreview = class extends Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.uid = Glob.generateUid(prefix);
		this.writeNew  = this.writeNew.bind(this);
	}
	writeNew() {
		Glob.trigger('WriteNewAvviso', { to: Glob.clone(this.props.notice.to) });
	}
	render() {
		const m = this.props.notice;
		if ( ! m?.id ) return <div className={prefix+' minimized'} />
		return (
			<div className={prefix+' message'}>
				<div className={"header"}>
					<div className={"elements"}>
						<div className={"usericon"}>
							<UserAvatar player={m.player}/>
						</div>
						<div className={"info"}>
							<div className={"date"}>
								<DateLabel value={m.time}/>
							</div>
							<div className={"people from"}>
								<em>
									<TextLabel value={"From"}/>:
								</em>
								<b>
									{ appLib.player2name(m.player) }
								</b>
							</div>
							<div className={"people to"}>
								<em>
									<TextLabel value={"Recipients"}/>:
								</em>
								<b>
									{m.to.length}
								</b>
							</div>
						</div>
						<div className={"controls"}>
							<Button
								className={"btn-icon"}
								color={"warning"}
								onClick={this.props.close}
							>
								<b>
									<TextLabel value={"Close"}/>
								</b>
								<i>
									<CloseIcon/>
								</i>
							</Button>
							<ButtonGroup className={"btn-icon"}>
								<Button
									onClick={ this.writeNew }
								>
									<i><ReplyAllIcon /></i>
									<b>
										<TextLabel value={"New notice"}/>
									</b>
								</Button>
								<Button
									onClick={ ()=> {
										this.setState({details: m.to})
									}}
									color={"primary"}
								>
									<i>
										<ReadIcon />
									</i>
								</Button>
							</ButtonGroup>
						</div>
					</div>
					<div className={"subject"}>
						{m.subject}
					</div>
				</div>
				<div className="body">
					{ m.body }
				</div>
				{ this.state.details && (
					<AvvisiPreviewRecipients
						list={this.state.details}
						onClose={ ()=>{ this.setState({details: false}) }}
					/>
				)}
			</div>
		);
	}
}

export default AvvisiPreview;